import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/layout/AppShell";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import BotPage from "@/pages/BotPage";
import ProfilesPage from "@/pages/ProfilesPage";
import PoolPage from "@/pages/PoolPage";
import SettingsPage from "@/pages/SettingsPage";
import OutboundPage from "@/pages/OutboundPage";

const Protected = () => {
  const { user, loading } = useAuth();
  if (loading) return <div className="app-loader" data-testid="app-loading">Carregando operação...</div>;
  return user ? <AppShell /> : <Navigate to="/login" replace />;
};

export default function App() {
  return <BrowserRouter><AuthProvider><Routes><Route path="/login" element={<LoginPage />} /><Route element={<Protected />}><Route index element={<DashboardPage />} /><Route path="bot" element={<BotPage />} /><Route path="perfis" element={<ProfilesPage />} /><Route path="pool" element={<PoolPage />} /><Route path="envio-apis" element={<OutboundPage />} /><Route path="configuracoes" element={<SettingsPage />} /></Route><Route path="*" element={<Navigate to="/" replace />} /></Routes><Toaster richColors position="top-right" /></AuthProvider></BrowserRouter>;
}